import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '../styles';
const useStyles = makeStyles(() => ({
    value: {
        marginLeft: 5,
        verticalAlign: 'middle',
    },
}));
function ProgressButton(props) {
    const { progress } = props;
    const styles = useStyles();
    return (React.createElement("div", null,
        !progress && (React.createElement("button", { type: "button", className: "button--primary upload-survey", onClick: props.submit }, props.children)),
        progress && (React.createElement("div", null,
            React.createElement("progress", { value: progress, max: "100" },
                progress,
                "%"),
            React.createElement("span", { className: styles.value },
                progress,
                "%")))));
}
ProgressButton.propTypes = {
    progress: PropTypes.number,
    submit: PropTypes.func.isRequired,
    children: PropTypes.element.isRequired,
};
export default ProgressButton;
//# sourceMappingURL=ProgressButton.js.map